import { useContext } from "react";
import BaseActions, { APIRequestGenerator } from "base/BaseActions";
import APIHelper from "base/APIHelper";
import BaseModel from "base/BaseModel";
import UserModel from "./userModel";

const module = "serviceAddOn";

const useServiceAddOn = (savedModelInstance = {}) => {
  const { Merchant, isSystem, token } = useContext(UserModel.Context);
  const { getList, getOne, createOne, updateOne, deleteOne, getSchema } =
    BaseActions(module, {
      Merchant,
      isSystem,
      token,
    });

  async function updatePriority(data) {
    const { url, headers } = APIRequestGenerator(
      `${process.env.REACT_APP_HOST}/${module}/priority`,
      null,
      token
    );
    try {
      const response = await APIHelper(
        "PUT",
        url.toString(),
        data,
        true,
        headers
      );

      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  return {
    getList,
    getOne,
    createOne,
    updateOne,
    deleteOne,
    getSchema,
    updatePriority,
  };
};

const ServiceAddOnModel = BaseModel(useServiceAddOn, "ServiceAddOnModel");

export { useServiceAddOn };
export default ServiceAddOnModel;
